"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const whiteChevron = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 12L10 8L6 4" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
let currentTimer;
/**
 * @desc base_react.html의 id="toast_message"인 div DOM조작
 * @prop isBottom - true일 때 토스트 메시지가 하단에 위치함
 * @prop toastAnchor - 토스트 메시지 오른쪽에 anchor tag 추가할 때, anchor tag의 href & 표시 text
 * @prop onClickAnchorAltFunc - 추가된 anchor tag 클릭시 대체 함수 (eg. 구독에서 찜 누른 후 '찜목록보기' 클릭했을 때 찜 탭으로 전환),
 * 반드시 toastAnchor가 있어야 적용 가능
 *
 * eg. toastAnchor: { href: '', text: '찜목록보기' }, onClickAnchorAltFunc: YOUR FUNC
 */
function default_1({ message, isBottom, toastAnchor, onClickAnchorAltFunc, beforeMessageIcon, }) {
    const toastDiv = document.getElementById('toast_message');
    const iconSpan = beforeMessageIcon
        ? `<img src=${beforeMessageIcon} width="20" height="20" style="margin-right:10px"/>`
        : '';
    const messageSpan = `<span style='font-size: 16px; line-height: 19px;'>${message}</span>`;
    const animation = isBottom ? 'fadeupdownbottom' : 'fadeupdowncenter';
    const removeToast = () => {
        if (currentTimer)
            window.clearTimeout(currentTimer);
        toastDiv.innerHTML = '';
        toastDiv.removeAttribute('style');
    };
    const addToastAnchor = () => {
        if (toastAnchor) {
            const contentCharsLeng = message.length + toastAnchor.text.length;
            const toastDivStyleObj = {
                flexWrap: 'wrap',
                justifyContent: contentCharsLeng > 18 ? 'center' : 'space-between',
                gap: '4px',
                pointerEvents: 'auto',
            };
            for (const property in toastDivStyleObj) {
                toastDiv.style[property] =
                    toastDivStyleObj[property];
            }
            const anchorEl = document.createElement('a');
            anchorEl.setAttribute('href', toastAnchor.href);
            anchorEl.classList.add('no_anchor_deco');
            const anchorStyleObj = {
                display: 'flex',
                alignItems: 'center',
                fontSize: '14px',
                lineHeight: '16px',
                color: 'white',
            };
            for (const property in anchorStyleObj) {
                anchorEl.style[property] =
                    anchorStyleObj[property];
            }
            if (onClickAnchorAltFunc) {
                anchorEl.onclick = e => {
                    e.preventDefault();
                    onClickAnchorAltFunc();
                    removeToast();
                };
            }
            anchorEl.innerHTML = toastAnchor.text + whiteChevron;
            toastDiv.appendChild(anchorEl);
        }
    };
    const showToast = () => {
        toastDiv.innerHTML = iconSpan + messageSpan;
        addToastAnchor();
        toastDiv.style.animation = `${animation} 3s`;
        toastDiv.style.visibility = 'visible';
    };
    removeToast();
    window.setTimeout(showToast, 100);
    currentTimer = window.setTimeout(() => {
        removeToast();
    }, 3000);
}
exports.default = default_1;
